var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 10.268C21.3333 11.0378 21.3333 12.9623 20 13.7321L3.5 23.2583C2.16667 24.0281 0.500001 23.0659 0.500001 21.5263L0.500002 2.47372C0.500002 0.934117 2.16667 -0.0281314 3.5 0.741669L20 10.268Z","fill":"#124350"}));
}

Play.defaultProps = {"viewBox":"0 0 21 24","fill":"none"};

module.exports = Play;

Play.default = Play;
